// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-filter-popover{margin-top:-18px;margin-left:-4px}.page-filter-popover .v-popper__arrow-container{display:none}`, "",{"version":3,"sources":["webpack://./src/components/PageList.vue"],"names":[],"mappings":"AACA,qBACC,gBAAA,CACA,gBAAA,CAEA,gDACC,YAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
